
import { sustainabilityImages } from '../../../utils/images';

export default function EthicalProductionSection() {
  const ethicalValues = [
    {
      icon: 'ri-shield-star-line',
      title: 'Fair Labor Practices',
      description: 'Ensuring fair labor practices, worker safety, and social responsibility.'
    },
    {
      icon: 'ri-team-line',
      title: 'Transparent Relationships',
      description: 'Building long-term, transparent relationships with our employees and partners.'
    },
    {
      icon: 'ri-earth-line',
      title: 'Global Standards',
      description: 'Dedicated to compliance with global ethical trade standards.'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1">
            <img
              src={sustainabilityImages.ethicalProduction}
              alt="Ethical Production Environment"
              className="w-full h-96 object-cover"
            />
          </div>

          <div className="order-1 lg:order-2 space-y-8">
            <div>
              <h2 className="text-4xl lg:text-5xl font-light text-gray-900 leading-tight mb-6">
                Ethical Production
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed font-light mb-8">
                Our commitment to ethical manufacturing goes beyond compliance—it's about creating a positive impact on the communities and people who make our products possible.
              </p>
            </div>

            <div className="space-y-6">
              {ethicalValues.map((value, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="w-12 h-12 text-green-600 flex items-center justify-center rounded-full bg-green-50 flex-shrink-0">
                    <i className={`${value.icon} text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-2">
                      {value.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed font-light">
                      {value.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="pt-6">
              <div className="bg-green-50 rounded-lg p-6">
                <div className="flex items-center space-x-3 mb-3">
                  <i className="ri-medal-line text-2xl text-green-600"></i>
                  <h4 className="text-lg font-medium text-gray-900">Our Promise</h4>
                </div>
                <p className="text-gray-700 font-light">
                  Every partner and worker in our supply chain is treated with dignity, respect, and fairness, ensuring sustainable livelihoods for all.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
